export default "/static/dashboard/build/app/img/v2/c8b6315a816cabe60639d8b63df62593.png";